var PaymentType;
(function (PaymentType) {
    PaymentType["NEW_CARD"] = "new card";
    PaymentType["REWARD_WALLET"] = "reward wallet";
    PaymentType["SAVED_CARD"] = "saved card";
})(PaymentType || (PaymentType = {}));
export default PaymentType;
